function SymError()
{
  return true;
}

window.onerror = SymError;

function firstFocus()
{
   if (document.forms.length > 0)
   {
      var TForm = document.forms[0];
      for (i=0;i<TForm.length;i++)
      {
         if ((TForm.elements[i].type=="text")||
           (TForm.elements[i].type=="textarea")||
           (TForm.elements[i].type.toString().charAt(0)=="s"))
         {
            document.forms[0].elements[i].focus();
            document.forms[0].elements[i].select();
            break;
         }
      }
   }
}

function formInit() {
	var query = window.location.search.substring(1);
	var pairs = query.split('&');
	
	for (var i=0;i<pairs.length;i++)
	{
		var pos = pairs[i].indexOf('=');
		if (pos >= 0)
		{
			var argname = pairs[i].substring(0,pos);
			var value = unescape(pairs[i].substring(pos+1));

			eval("document.servform." + argname + ".value = '" + value + "'");	
		}
	}

	firstFocus();
}

window.onload = formInit;